<mat-form-field appearance="outline" subscriptSizing="dynamic">
  <mat-label *ngIf="label"> {{ label }} </mat-label>

  <input
    *ngIf="type == 'number' || type == 'percentage'; else numberStringInput"
    matInput
    [formControl]="modelCtrl"
    [required]="required"
    [mask]="type == 'percentage' ? 'percent.2' : 'separator.' + decimalPrecision"
    thousandSeparator=","
    [allowNegativeNumbers]="allowNegativeNumbers"
    [placeholder]="placeholder"
    [errorStateMatcher]="errorStateMatcher"
  />

  <ng-template #numberStringInput>
    <input
      *ngIf="type == 'numberString'; else stringInput"
      matInput
      [formControl]="modelCtrl"
      [required]="required"
      mask="0*"
      [placeholder]="placeholder"
      [errorStateMatcher]="errorStateMatcher"
    />
  </ng-template>

  <ng-template #stringInput>
    <input
      matInput
      [type]="type"
      [formControl]="modelCtrl"
      [required]="required"
      [placeholder]="placeholder"
      [errorStateMatcher]="errorStateMatcher"
    />
  </ng-template>

  <mat-icon *ngIf="prefixIcon" matPrefix> {{ prefixIcon }} </mat-icon>

  <span matTextPrefix *ngIf="prefixText"> {{ prefixText }}&nbsp;</span>

  <span matTextSuffix *ngIf="suffixText"> {{ suffixText }}&nbsp;</span>

  <button *ngIf="suffixIcon" mat-icon-button matSuffix (click)="onSuffixBtnClick()">
    <mat-icon> {{ suffixIcon }} </mat-icon>
  </button>

  <mat-icon *ngIf="infoText" class="input-info-suffix" matSuffix [matTooltip]="infoText"> info </mat-icon>

  <mat-hint *ngIf="hint"> {{ hint }} </mat-hint>

  <mat-hint *ngIf="rangeHintText" align="end"> {{ rangeHintText }} </mat-hint>

  <mat-error *ngIf="modelCtrl.invalid && modelCtrl.touched && modelCtrl.dirty">
    @if (required && !modelCtrlValue) {
      Please enter a value
    } @else {
      @for (errorKey of errorMessageKeys; track errorKey) {
        @if (modelCtrl.hasError(errorKey)) {
          {{ errorMessages[errorKey] }}
        }
      }
    }
  </mat-error>
</mat-form-field>
